<template>
  
</template>

<script>
import image from '@/assets/Logo.png'
export default {
   data: () => ({
      image: image
    }),
};
</script>